{
    "apartmentInfo": {
        "info": "*alle Preisangaben sind inkl. MwSt. und zzgl. Kurtaxe"
    },
    "booking": {
        "bookingForm": {
            "daysSelected": "Tage ausgewählt",
            "selectMinNDays": "Mind. {{days}} Tage auswählen",
            "maxNPersons": "Max. {{persons}} Personen",
            "adultsAge": "Erwachsene (ab 12 Jahre)",
            "childrenAge": "Kinder (6-11 Jahre)",
            "infantsAge": "Kleinkinder (bis 5 Jahre)",
            "nights": "Nächte",
            "cleaningCosts": "Reinigungskosten",
            "totalPrice": "Gesamtpreis",
            "reserve": "Reservieren",
            "bookingsNotPossible": "Buchungen sind derzeit nicht möglich. Versuche es bitte später erneut.",
            "minimumStay": "Mindestaufenthalt",
            "from": "ab",
            "to": "bis",
            "noPets": "Keine Haustiere",
            "maxPersonAmountReached": "Maximale Personen-Anzahl erreicht",
            "minPersonAmountReached": "Minimale Personen-Anzahl erreicht"
        },
        "bookingFullForm": {
            "createNonBindingRequest": "Unverbindliche Anfrage erstellen",
            "firstName": "Vorname",
            "lastName": "Nachname",
            "street": "Straße",
            "houseNumber": "Hausnummer",
            "postalCode": "Postleitzahl",
            "place": "Ort",
            "phoneNumber": "Telefonnummer",
            "message": "Nachricht",
            "yourMessageToUs": "Ihre Nachricht an uns...",
            "agreeTo": "Ich akzeptiere die",
            "privacyPolicy": "Datenschutzerklärung",
            "submitRequest": "Anfrage abschicken",
            "isRequired": "ist erforderlich",
            "isInvalid": "ist ungültig",
            "isTooShort": "ist zu kurz",
            "isTooLong": "ist zu lang",
            "success": "Ihre Anfrage wurde erfolgreich versendet.",
            "errorSendingRequest": "Ihre Anfrage konnte nicht versendet werden.",
            "checkInPast": "Check-In kann nicht in der Vergangenheit liegen.",
            "checkOutBeforeCheckIn": "Check-Out kann nicht vor Check-In liegen.",
            "minimumStay": "Mindestens {{nights}} Nächte buchbar.",
            "maximumStay": "Maximal {{nights}} Nächte buchbar.",
            "reservationConflict": "Es wurde gerade eine Reservierung für diesen Zeitraum getätigt. Bitte wählen Sie einen anderen Zeitraum.",
            "invalidForm": "Bitte füllen Sie alle erforderlichen Felder korrekt aus. Inklusive der Check-In und Check-Out Daten."
        },
        "retry": "Erneut versuchen"
    },
    "contactApartment": {
        "stillQuestions": "Noch Fragen?",
        "contactApartment": "Kontaktiere unser Apartment",
        "contactForm": {
            "your": "Dein",
            "name": "Name",
            "firstLastName": "Vor- und Nachname",
            "writeMessage": "Schreibe uns eine Nachricht..."
        }
    },
    "contactYard": {
        "contactUs": "Kontaktiere uns",
        "contact": "Kontakt"
    },
    "footer": {
        "findUsHere": "Hier findest du uns",
        "book": "Buchen",
        "imprint": "Impressum",
        "dataProtection": "Datenschutz",
        "termsAndConditions": "AGB",
        "austria": "Österreich",
        "farm": "Bauernhof",
        "toShop": "Zum Shop"
    },
    "notFound": {
        "siteNotFound": "Diese Seite konnte nicht gefunden werden.",
        "notFound": "Nicht gefunden",
        "toHome": "Zur Startseite"
    },
    "priceView": {
        "season": "{{name}}saison",
        "showPrices": "Preise anzeigen",
        "persons": "Personen",
        "adults": "Erwachsene",
        "children": "Kinder",
        "cleaningCosts": "Reinigungskosten",
        "bookNow": "Jetzt buchen",
        "priceTableHeader": "Preistabelle für {{seasonName}}saison (Preise pro Nacht)",
        "basePriceInfo": "Bis {{minimumPeople}} Personen wird mit einem Basispreis von {{basePrice}} € sowie Reinigungskosten von {{cleaningCosts}} € gerechnet.",
        "additionalPersonInfo": "Jede weitere Person +{{cleaningCostsPerPerson}} € Reinigungskosten.",
        "additionalAdultInfo": "Danach jeder weitere Erwachsene +{{adultPrice}} €.",
        "additionalChildInfo": "Jedes weitere Kind +{{childPrice}} €."
    },
    "product": {
        "addToCart": "In den Warenkorb",
        "selectWeight": "Gewicht auswählen",
        "yourCartIsEmpty": "Dein Warenkorb ist leer",
        "goToCheckout": "Zur Kasse",
        "buyNow": "Jetzt kaufen",
        "notFound": "Produkt konnte nicht gefunden werden.",
        "productNotFound": "Das gesuchte Produkt konnte nicht gefunden werden.",
        "inclVat": "inkl. MwSt.",
        "toProduct": "Zum Produkt",
        "delete": "Entfernen",
        "noProductsForCategory": "Keine Produkte in dieser Kategorie verfügbar.",
        "maxAmount": "Maximale Anzahl erreicht",
        "minOne": "Muss mindestens 1 sein",
        "onlyXLeft": "Nur noch {{amount}} verfügbar",
        "outOfStock": "Ausverkauft",
        "currentlyOutOfStock": "Dieser Artikel ist derzeit ausverkauft.",
        "available": "Derzeit verfügbar",
        "chooseDeliveryDate": "Lieferdatum wählen",
        "chooseAmount": "Menge wählen",
        "chooseWeight": "Gewicht wählen",
        "chooseVariant": "Variante wählen",
        "notAvailableAnymore": "Produkt nicht mehr verfügbar.",
        "removedFromCart": "Produkt aus dem Warenkorb entfernt.",
        "productUnavailable": "Das Produkt {{productName}} ist nicht mehr verfügbar.",
        "variantUnavailable": "Die ausgewählte Variante {{variant}} des Produkts {{productName}} ist nicht mehr verfügbar.",
        "deliveryDateUnavailable": "Das ausgewählte Lieferdatum {{selectedDeliveryDate}} für das Produkt {{productName}} ist nicht mehr verfügbar.",
        "maxAmountOfVariant": "Du kannst nur bis zu {{amount}} Artikel dieser Variante in deinen Warenkorb legen.",
        "maxDifferentDeliverydates": "Du kannst nur bis zu 3 verschiedene Liefertermine in deinen Warenkorb legen.",
        "allProducts": "Alle Produkte: {{category}}"
    },
    "shop": {
        "theBestFromYard": "Das Beste vom Hof -",
        "directlyToYourHome": "Direkt zu euch",
        "categories": "Kategorien",
        "allCategories": "Alle Kategorien",
        "priceRange": "Preisspanne",
        "searchPlaceholder": "Produkte suchen...",
        "noProductsFound": "Keine Produkte für diese Kriterien gefunden.",
        "sortBy": "Sortieren nach",
        "filterBy": "Filtern nach",
        "sortByNameAsc": "Name aufsteigend (A-Z)",
        "sortByNameDesc": "Name absteigend (Z-A)",
        "sortByPriceAsc": "Preis aufsteigend (niedrigster zuerst)",
        "sortByPriceDesc": "Preis absteigend (höchster zuerst)",
        "sortByNewest": "Neueste zuerst",
        "sortByOldest": "Älteste zuerst",
        "deliveryDate": "Lieferdatum",
        "ordersSoonAvailable": "Bestellungen sind in Kürze wieder möglich."
    },
    "blog": {
        "readMore": "Mehr lesen",
        "nextBlogPost": "Nächster Blogeintrag",
        "close": "Schließen"
    },
    "newsletter": {
        "error": "Leider ist etwas schiefgelaufen. Bitte versuche es erneut.",
        "subscribeToOurNewsletter": "Alle Fleisch-Termine per E-Mail erhalten",
        "register": "Anmelden",
        "enterEmail": "E-Mail eingeben"
    },
    "cookie": {
        "header": "Diese Website verwendet Cookies!",
        "message": "Diese Website verwendet Cookies, um sicherzustellen, dass Sie die bestmögliche Erfahrung auf unserer Website erzielen.",
        "dismiss": "Verstanden",
        "allow": "Zulassen",
        "deny": "Ablehnen",
        "link": "Mehr erfahren",
        "policy": "Cookie-Richtlinie"
    },
    "categories": {
        "ourCategories": "Unsere Kategorien"
    }
}